export const environment = {
  production: true,
  api:'https://us-central1-ledube-fd494.cloudfunctions.net'
}


// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/environments/environment.ts